// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"41":"00d56fd9","299":"c5a25b15"}[chunkId] + ".chunk.css";
};